import { render, staticRenderFns } from "./AdminGlobalReports.vue?vue&type=template&id=033750d7&scoped=true&"
import script from "./AdminGlobalReports.vue?vue&type=script&lang=js&"
export * from "./AdminGlobalReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminGlobalReports.vue?vue&type=style&index=0&id=033750d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033750d7",
  null
  
)

export default component.exports